export default "__VITE_ASSET__YbiaRNvs__"